module.exports = __webpack_public_path__ + "static/media/IconTemplates_-60.88640f17.svg";